import { connect } from 'react-redux'
import { getRecaptchaKey } from '../../redux/app/selectors'
import ReCaptcha from './ReCaptcha.jsx'
import { getLocale } from '../../redux/app/selectors'

const mapStateToProps = state => ({
    recaptchaKey: getRecaptchaKey(state),
    locale: getLocale(state),
})

export const ReCaptchaContainer = connect(
    mapStateToProps,
)(ReCaptcha)
